import {
  Add as AddIcon,
  CloudUpload as CloudUploadIcon,
  ContentCopy as ContentCopyIcon,
  Delete as DeleteIcon,
  Download as DownloadIcon,
  Edit as EditIcon,
  Filter as FilterIcon,
  Search as SearchIcon,
  Upload as UploadIcon,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Snackbar,
  TablePagination,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import * as XLSX from "xlsx";
import ResponsiveTable from "../components/ResponsiveTable";
import { useAuth } from "../context/AuthContext";
import {
  adminService,
  cepService,
  clienteService,
  recorrenciaService,
  setorService,
  tipoObrigacaoService,
} from "../services/api";
// Função para formatar CPF/CNPJ
const formatCPFCNPJ = (value) => {
  const numbers = value.replace(/\D/g, "");

  // Se tem 11 dígitos, formata como CPF
  if (numbers.length <= 11) {
    return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  // Se tem 14 dígitos, formata como CNPJ
  if (numbers.length <= 14) {
    return numbers.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5",
    );
  }

  return value;
};

const Clientes = () => {
  const { user } = useAuth();

  // ✅ CONFIGURAÇÃO DOS TAMANHOS DOS FILTROS - CSS PURO RESPONSIVO!
  // Valores de 0 a 100 (porcentagem da largura no desktop)
  // Mobile: sempre 100% (empilhados)
  // 💡 TESTE: Mude os valores e veja a diferença imediatamente!
  const TAMANHOS_FILTROS = {
    busca: 50, // 50% da largura no desktop - Campo de busca
    status: 25, // 25% da largura no desktop - Campo de status
    escritorio: 25, // 25% da largura no desktop - Campo de escritório
  };

  const [clientes, setClientes] = useState([]);
  const [escritorios, setEscritorios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [excluindo, setExcluindo] = useState(false);
  const [filtros, setFiltros] = useState({
    busca: "",
    ativo: "",
    escritorio_id_filter: "",
  });
  const [paginacao, setPaginacao] = useState({
    page: 0,
    limit: 10,
    total: 0,
  });

  // Estados para modal de cliente
  const [modalAberto, setModalAberto] = useState(false);
  const [clienteEditando, setClienteEditando] = useState(null);
  const [dadosCliente, setDadosCliente] = useState({
    nome: "",
    fantasia: "",
    cnpj: "",
    telefone: "",
    email: "",
    natureza: "",
    logradouro: "",
    numero: "",
    complemento: "",
    cep: "",
    bairro: "",
    cidade: "",
    uf: "",
    ativo: true,
    regime_tributario: "",
    observacoes: "",
  });
  // Tipos de obrigação para orientar no cadastro do cliente
  const [tiposObrigacoesDisponiveis, setTiposObrigacoesDisponiveis] =
    useState(null);
  const [carregandoTiposObrigacao, setCarregandoTiposObrigacao] =
    useState(false);
  const [cnpjError, setCnpjError] = useState(null);

  // Estados para notificações
  const [snackbar, setSnackbar] = useState({
    aberto: false,
    mensagem: "",
    tipo: "success",
  });

  // Estados para modal de recorrências automáticas
  const [modalRecorrenciasAberto, setModalRecorrenciasAberto] = useState(false);
  const [clienteCriado, setClienteCriado] = useState(null);
  const [recorrenciasSelecionadas, setRecorrenciasSelecionadas] = useState([]);
  const [setores, setSetores] = useState([]);
  const [loadingRecorrencias, setLoadingRecorrencias] = useState(false);

  // Estados para confirmação de exclusão
  const [confirmacaoExclusao, setConfirmacaoExclusao] = useState({
    aberto: false,
    clienteId: null,
    clienteNome: "",
  });

  // Estados para confirmação de exclusão de recorrência
  const [confirmacaoExclusaoRecorrencia, setConfirmacaoExclusaoRecorrencia] =
    useState({
      aberto: false,
      recorrenciaId: null,
      tipoObrigacaoDescricao: "",
      clienteNome: "",
    });
  const [excluindoRecorrencia, setExcluindoRecorrencia] = useState(false);

  // Estado para controlar visibilidade dos filtros
  const [mostrarFiltros, setMostrarFiltros] = useState(false);

  const [buscandoCNPJ, setBuscandoCNPJ] = useState(false);
  const [buscandoCEP, setBuscandoCEP] = useState(false);

  // Estados para importação de clientes
  const [modalImportacaoAberto, setModalImportacaoAberto] = useState(false);
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [importandoClientes, setImportandoClientes] = useState(false);
  const [resultadoImportacao, setResultadoImportacao] = useState(null);
  const [progressoImportacao, setProgressoImportacao] = useState(0);

  // Estados para cópia de recorrências
  const [modalCopiaRecorrenciasAberto, setModalCopiaRecorrenciasAberto] =
    useState(false);
  const [clienteOrigemCopia, setClienteOrigemCopia] = useState(null);
  const [clientesSelecionadosCopia, setClientesSelecionadosCopia] = useState(
    [],
  );
  const [todosSelecionados, setTodosSelecionados] = useState(false);
  const [copiandoRecorrencias, setCopiandoRecorrencias] = useState(false);
  const [resultadoCopia, setResultadoCopia] = useState(null);

  // Lista de UFs do Brasil
  const UF_LIST = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];

  const carregarEscritorios = useCallback(async () => {
    try {
      const response = await adminService.getEscritorios();
      setEscritorios(Array.isArray(response) ? response : []);
    } catch (error) {
      console.error("Erro ao carregar escritórios:", error);
    }
  }, []);

  const carregarClientes = useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        page: paginacao.page + 1,
        limit: paginacao.limit,
      };

      if (filtros.busca) params.busca = filtros.busca;
      if (filtros.ativo !== "") params.ativo = filtros.ativo;
      if (filtros.escritorio_id_filter)
        params.escritorio_id_filter = filtros.escritorio_id_filter;

      // Filtrar apenas clientes criados pelo usuário logado
      if (user?.id) {
        params.criado_por_id = user.id;
      }

      const response = await clienteService.getAll(params);
      setClientes(response.clientes);
      setPaginacao((prev) => ({
        ...prev,
        total: response.pagination.total,
      }));
    } catch (error) {
      mostrarSnackbar("Erro ao carregar clientes: " + error.message, "error");
    } finally {
      setLoading(false);
    }
  }, [paginacao.page, paginacao.limit, filtros, user]);

  useEffect(() => {
    // Só carrega clientes se o usuário estiver disponível
    if (user?.id) {
      carregarClientes();
    }
    if (user?.is_super_admin) {
      carregarEscritorios();
    }
  }, [carregarClientes, carregarEscritorios, user]);

  const mostrarSnackbar = (mensagem, tipo = "success") => {
    setSnackbar({
      aberto: true,
      mensagem,
      tipo,
    });
  };

  // Função para carregar setores
  const carregarSetores = useCallback(async () => {
    try {
      const response = await setorService.getAll({ limit: 100 });
      setSetores(response.setores || []);
    } catch (error) {
      console.error("Erro ao carregar setores:", error);
    }
  }, []);

  // Carregar setores quando o componente monta
  useEffect(() => {
    carregarSetores();
  }, [carregarSetores]);

  // Detectar quando o usuário volta para a página e verificar se o arquivo ainda é válido
  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (!document.hidden && arquivoSelecionado) {
        try {
          // Tentar ler um pequeno pedaço do arquivo para verificar se ainda é acessível
          await arquivoSelecionado.slice(0, 100).arrayBuffer();
        } catch (error) {
          // Arquivo não está mais disponível
          setArquivoSelecionado(null);
          const fileInput = document.getElementById("arquivo-upload");
          if (fileInput) fileInput.value = "";
          mostrarSnackbar(
            "O arquivo foi modificado ou movido. Selecione o arquivo novamente.",
            "warning",
          );
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [arquivoSelecionado]);

  // Função para abrir modal de recorrências automáticas
  const abrirModalRecorrencias = async (cliente) => {
    try {
      setLoadingRecorrencias(true);

      // Buscar TODOS os tipos de obrigação
      const response = await tipoObrigacaoService.getAll();
      const todosOsTipos = response.tipos_obrigacoes || [];

      if (todosOsTipos.length === 0) {
        mostrarSnackbar("Não há tipos de obrigação cadastrados", "info");
        return;
      }

      // Buscar recorrências existentes para este cliente
      const recorrenciasExistentesResponse = await recorrenciaService.getAll({
        cliente_id: cliente.id,
        limit: 100, // Buscar todas as recorrências do cliente
      });
      const recorrenciasExistentes =
        recorrenciasExistentesResponse.recorrencias || [];

      setClienteCriado(cliente);

      // Inicializar recorrências com todos os tipos
      const recorrenciasIniciais = todosOsTipos.map((tipo) => {
        // Verificar se já existe recorrência para este tipo
        const recorrenciaExistente = recorrenciasExistentes.find(
          (rec) => rec.tipo_obrigacao_id === tipo.id,
        );

        // Se cliente não tem regime tributário, nenhuma obrigação é compatível
        let isCompatible = false;
        let selecionado = false;

        if (cliente.regime_tributario) {
          // Verificar se o tipo é compatível com o regime do cliente
          isCompatible = tipo[cliente.regime_tributario] === true;
          // Só pré-selecionar se for compatível E não existir recorrência
          selecionado = isCompatible && !recorrenciaExistente;
        }

        return {
          tipo_obrigacao_id: tipo.id,
          setor_id: tipo.setor?.id || null,
          selecionado, // Desmarcado se sem regime, compatíveis se com regime, ou já existe
          tipo_obrigacao: tipo,
          isCompatible, // Flag para ordenação e indicação visual
          jaExiste: !!recorrenciaExistente, // Flag para indicar se já existe
          recorrenciaExistente: recorrenciaExistente || null, // Dados da recorrência existente (incluindo ID)
        };
      });

      // Ordenar: compatíveis primeiro, depois os outros
      const recorrenciasOrdenadas = recorrenciasIniciais.sort((a, b) => {
        // Se ambos são compatíveis ou ambos não são, manter ordem alfabética
        if (a.isCompatible === b.isCompatible) {
          return a.tipo_obrigacao.descricao.localeCompare(
            b.tipo_obrigacao.descricao,
          );
        }
        // Compatíveis primeiro (true vem antes de false)
        return b.isCompatible - a.isCompatible;
      });

      setRecorrenciasSelecionadas(recorrenciasOrdenadas);
      setModalRecorrenciasAberto(true);
    } catch (error) {
      mostrarSnackbar(
        "Erro ao carregar tipos de obrigação: " + error.message,
        "error",
      );
    } finally {
      setLoadingRecorrencias(false);
    }
  };

  // Função para confirmar exclusão de recorrência
  const confirmarExclusaoRecorrencia = (recorrencia) => {
    setConfirmacaoExclusaoRecorrencia({
      aberto: true,
      recorrenciaId: recorrencia.id,
      tipoObrigacaoDescricao: recorrencia.tipo_obrigacao.descricao,
      clienteNome: clienteCriado?.nome || "",
    });
  };

  // Função para excluir recorrência
  const excluirRecorrencia = async () => {
    if (excluindoRecorrencia) return; // Evita cliques duplos

    try {
      setExcluindoRecorrencia(true);

      const response = await recorrenciaService.deleteWithObrigacoes(
        confirmacaoExclusaoRecorrencia.recorrenciaId,
      );

      // Mostrar mensagem de sucesso com detalhes
      let mensagem = `Recorrência excluída com sucesso!`;
      if (response.obrigacoes_excluidas > 0) {
        mensagem += ` ${response.obrigacoes_excluidas} obrigação(ões) pendente(s) também foram excluídas.`;
      }

      mostrarSnackbar(mensagem, "success");

      // Fechar modal de confirmação
      setConfirmacaoExclusaoRecorrencia({
        aberto: false,
        recorrenciaId: null,
        tipoObrigacaoDescricao: "",
        clienteNome: "",
      });

      // Recarregar as recorrências no modal
      await abrirModalRecorrencias(clienteCriado);
    } catch (error) {
      mostrarSnackbar("Erro ao excluir recorrência: " + error.message, "error");
    } finally {
      setExcluindoRecorrencia(false);
    }
  };

  const fecharModalRecorrencias = () => {
    setModalRecorrenciasAberto(false);
    setClienteCriado(null);
    setRecorrenciasSelecionadas([]);
  };

  // Função para toggle de seleção de recorrência
  const toggleRecorrencia = (tipoObrigacaoId) => {
    setRecorrenciasSelecionadas((prev) =>
      prev.map((rec) =>
        rec.tipo_obrigacao_id === tipoObrigacaoId && !rec.jaExiste
          ? { ...rec, selecionado: !rec.selecionado }
          : rec,
      ),
    );
  };

  // Função para alterar setor de uma recorrência
  const alterarSetorRecorrencia = (tipoObrigacaoId, setorId) => {
    setRecorrenciasSelecionadas((prev) =>
      prev.map((rec) =>
        rec.tipo_obrigacao_id === tipoObrigacaoId
          ? { ...rec, setor_id: setorId || null }
          : rec,
      ),
    );
  };

  // Função para criar recorrências em lote
  const criarRecorrenciasLote = async () => {
    try {
      const recorrenciasSelecionadasFiltradas = recorrenciasSelecionadas.filter(
        (rec) => rec.selecionado && !rec.jaExiste,
      );

      if (recorrenciasSelecionadasFiltradas.length === 0) {
        mostrarSnackbar(
          "Selecione pelo menos uma obrigação para criar as recorrências",
          "warning",
        );
        return;
      }

      setLoadingRecorrencias(true);

      const dadosLote = {
        cliente_id: clienteCriado.id,
        recorrencias: recorrenciasSelecionadasFiltradas.map((rec) => ({
          tipo_obrigacao_id: rec.tipo_obrigacao_id,
          setor_id: rec.setor_id,
        })),
      };

      const response = await recorrenciaService.createBatch(dadosLote);

      const { recorrencias_criadas, obrigacoes_criadas, erros } = response;

      let mensagem = `${recorrencias_criadas} recorrência(s) criada(s) com sucesso!`;
      if (obrigacoes_criadas > 0) {
        mensagem += ` ${obrigacoes_criadas} obrigação(ões) gerada(s) automaticamente.`;
      }
      if (erros > 0) {
        mensagem += ` ${erros} erro(s) encontrado(s).`;
      }

      mostrarSnackbar(mensagem, erros > 0 ? "warning" : "success");
      fecharModalRecorrencias();
    } catch (error) {
      mostrarSnackbar("Erro ao criar recorrências: " + error.message, "error");
    } finally {
      setLoadingRecorrencias(false);
    }
  };

  const handleFiltroChange = (campo, valor) => {
    setFiltros((prev) => ({
      ...prev,
      [campo]: valor,
    }));
    setPaginacao((prev) => ({ ...prev, page: 0 }));
  };

  const abrirModalCliente = (cliente = null) => {
    if (cliente) {
      setClienteEditando(cliente);
      setDadosCliente({
        nome: cliente.nome || "",
        fantasia: cliente.fantasia || "",
        cnpj: cliente.cnpj || "",
        telefone: cliente.telefone || "",
        email: cliente.email || "",
        natureza: cliente.natureza || "",
        logradouro: cliente.logradouro || "",
        numero: cliente.numero || "",
        complemento: cliente.complemento || "",
        cep: cliente.cep || "",
        bairro: cliente.bairro || "",
        cidade: cliente.cidade || "",
        uf: cliente.uf || "",
        ativo: cliente.ativo !== undefined ? cliente.ativo : true,
        regime_tributario: cliente.regime_tributario || "",
        observacoes: cliente.observacoes || "",
      });
    } else {
      setClienteEditando(null);
      setDadosCliente({
        nome: "",
        fantasia: "",
        cnpj: "",
        telefone: "",
        email: "",
        natureza: "",
        logradouro: "",
        numero: "",
        complemento: "",
        cep: "",
        bairro: "",
        cidade: "",
        uf: "",
        ativo: true,
        regime_tributario: "",
        observacoes: "",
      });
    }
    setModalAberto(true);
  };

  // Carrega tipos de obrigação ao abrir o modal de cliente para exibir orientação se vazio
  useEffect(() => {
    const carregarTiposObrigacaoParaOrientacao = async () => {
      try {
        setCarregandoTiposObrigacao(true);
        const response = await tipoObrigacaoService.getAll({ limit: 1 });
        setTiposObrigacoesDisponiveis(response.tipos_obrigacoes || []);
      } catch (error) {
        // Mantém nulo para não mostrar alerta indevido
        setTiposObrigacoesDisponiveis([]);
      } finally {
        setCarregandoTiposObrigacao(false);
      }
    };

    if (modalAberto) {
      carregarTiposObrigacaoParaOrientacao();
    }
  }, [modalAberto]);

  const fecharModal = () => {
    setModalAberto(false);
    setClienteEditando(null);
    setCnpjError(null);
  };

  const handleInputChange = (campo, valor) => {
    setDadosCliente((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const salvarCliente = async () => {
    if (salvando) return; // Evita cliques duplos

    try {
      setSalvando(true);

      if (!dadosCliente.nome.trim()) {
        mostrarSnackbar("Nome é obrigatório", "error");
        return;
      }

      if (clienteEditando) {
        const clienteAtualizado = await clienteService.update(
          clienteEditando.id,
          dadosCliente,
        );
        mostrarSnackbar("Cliente atualizado com sucesso!");
        fecharModal();
        carregarClientes();

        // Abrir modal de recorrências automáticas para atualização também
        await abrirModalRecorrencias(clienteAtualizado);
      } else {
        const novoCliente = await clienteService.create(dadosCliente);
        mostrarSnackbar("Cliente criado com sucesso!");
        fecharModal();
        carregarClientes();

        // Abrir modal de recorrências automáticas
        await abrirModalRecorrencias(novoCliente);
      }
    } catch (error) {
      mostrarSnackbar("Erro ao salvar cliente: " + error.message, "error");
    } finally {
      setSalvando(false);
    }
  };

  const confirmarExclusao = (cliente) => {
    setConfirmacaoExclusao({
      aberto: true,
      clienteId: cliente.id,
      clienteNome: cliente.nome,
    });
  };

  const excluirCliente = async () => {
    if (excluindo) return; // Evita cliques duplos

    try {
      setExcluindo(true);
      await clienteService.delete(confirmacaoExclusao.clienteId);
      mostrarSnackbar("Cliente excluído com sucesso!");
      setConfirmacaoExclusao({
        aberto: false,
        clienteId: null,
        clienteNome: "",
      });
      carregarClientes();
    } catch (error) {
      mostrarSnackbar("Erro ao excluir cliente: " + error.message, "error");
    } finally {
      setExcluindo(false);
    }
  };

  const buscarCNPJ = async () => {
    if (
      !dadosCliente.cnpj ||
      dadosCliente.cnpj.replace(/\D/g, "").length !== 14
    ) {
      setCnpjError("Informe um CNPJ válido (14 dígitos) para buscar.");
      return;
    }
    setBuscandoCNPJ(true);
    try {
      const data = await clienteService.consultaCNPJ(dadosCliente.cnpj);
      setDadosCliente((prev) => ({
        ...prev,
        nome: data.nome || prev.nome,
        fantasia: data.fantasia || prev.fantasia,
        cnpj: data.cnpj || prev.cnpj,
        telefone: data.telefone || prev.telefone,
        email: data.email || prev.email,
        natureza: data.natureza || prev.natureza,
        logradouro: data.logradouro || prev.logradouro,
        numero: data.numero || prev.numero,
        complemento: data.complemento || prev.complemento,
        cep: data.cep || prev.cep,
        bairro: data.bairro || prev.bairro,
        cidade: data.cidade || prev.cidade,
        uf: data.uf || prev.uf,
      }));

      // Se o CEP foi preenchido pelo CNPJ e não temos endereço completo, busca o CEP
      if (
        data.cep &&
        (!data.logradouro || !data.bairro || !data.cidade || !data.uf)
      ) {
        buscarCEP(data.cep);
      }
      setCnpjError(null);
      mostrarSnackbar("Dados do CNPJ preenchidos automaticamente.");
    } catch (error) {
      const responseData = error && error.response && error.response.data;
      const rawMessage =
        (responseData && (responseData.message || responseData.error)) ||
        (typeof responseData === "string" ? responseData : null) ||
        error?.message ||
        "";
      const lowerMsg = String(rawMessage).toLowerCase();
      let friendlyMessage = rawMessage;
      if (
        lowerMsg.includes("not in cache") ||
        lowerMsg.includes("not_found") ||
        lowerMsg.includes("not found")
      ) {
        friendlyMessage = "CNPJ inexistente na Receita Federal";
      }
      setCnpjError(friendlyMessage || "Erro ao buscar CNPJ.");
    } finally {
      setBuscandoCNPJ(false);
    }
  };

  // Função para buscar CEP
  const buscarCEP = async (cep) => {
    const cepLimpo = cep.replace(/\D/g, "");

    // Só busca se tiver 8 dígitos
    if (cepLimpo.length !== 8) {
      return;
    }

    setBuscandoCEP(true);
    try {
      const data = await cepService.buscarCEP(cep);

      setDadosCliente((prev) => ({
        ...prev,
        logradouro: data.logradouro || prev.logradouro,
        bairro: data.bairro || prev.bairro,
        cidade: data.localidade || prev.cidade,
        uf: data.uf || prev.uf,
      }));
    } catch (error) {
      console.error("Erro ao buscar CEP:", error.message);
      // Não mostra erro para o usuário, apenas no console
    } finally {
      setBuscandoCEP(false);
    }
  };

  // Função para formatar CEP
  const formatarCEP = (value) => {
    const cepLimpo = value.replace(/\D/g, "");
    return cepLimpo.replace(/(\d{5})(\d{3})/, "$1-$2");
  };

  // Função para gerar e baixar modelo Excel
  const baixarModeloExcel = () => {
    const colunas = [
      "Nome*",
      "Nome Fantasia",
      "CPF/CNPJ",
      "Email",
      "Telefone",
      "Natureza",
      "Regime Tributário",
      "CEP",
      "Logradouro",
      "Número",
      "Complemento",
      "Bairro",
      "Cidade",
      "UF",
      "Observações",
    ];

    const exemplo = [
      "Empresa Exemplo Ltda",
      "Exemplo",
      "12.345.678/0001-90",
      "contato@exemplo.com",
      "(11) 9999-9999",
      "Sociedade Empresária Limitada",
      "Simples Nacional",
      "01234-567",
      "Rua das Flores",
      "123",
      "Sala 101",
      "Centro",
      "São Paulo",
      "SP",
      "Cliente importante",
    ];

    const ws = XLSX.utils.aoa_to_sheet([colunas, exemplo]);

    // Ajustar largura das colunas
    const wscols = [
      { wch: 25 }, // Nome
      { wch: 20 }, // Nome Fantasia
      { wch: 18 }, // CPF/CNPJ
      { wch: 25 }, // Email
      { wch: 15 }, // Telefone
      { wch: 30 }, // Natureza
      { wch: 18 }, // Regime Tributário
      { wch: 12 }, // CEP
      { wch: 25 }, // Logradouro
      { wch: 8 }, // Número
      { wch: 15 }, // Complemento
      { wch: 20 }, // Bairro
      { wch: 20 }, // Cidade
      { wch: 5 }, // UF
      { wch: 30 }, // Observações
    ];
    ws["!cols"] = wscols;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Clientes");

    XLSX.writeFile(wb, "modelo_importacao_clientes.xlsx");
  };

  // Função para normalizar CEP (apenas números e traços)
  const normalizarCEP = (valor) => {
    if (!valor) return "";

    // Remove tudo exceto números e traços
    const cepLimpo = valor.toString().replace(/[^0-9-]/g, "");

    // Se tiver 8 dígitos, formata automaticamente
    if (cepLimpo.replace(/\D/g, "").length === 8) {
      const numeros = cepLimpo.replace(/\D/g, "");
      return numeros.replace(/(\d{5})(\d{3})/, "$1-$2");
    }

    return cepLimpo;
  };

  // Mapeamento de estados brasileiros
  const ESTADOS_BRASIL = {
    // Siglas
    ac: "AC",
    al: "AL",
    ap: "AP",
    am: "AM",
    ba: "BA",
    ce: "CE",
    df: "DF",
    es: "ES",
    go: "GO",
    ma: "MA",
    mt: "MT",
    ms: "MS",
    mg: "MG",
    pa: "PA",
    pb: "PB",
    pr: "PR",
    pe: "PE",
    pi: "PI",
    rj: "RJ",
    rn: "RN",
    rs: "RS",
    ro: "RO",
    rr: "RR",
    sc: "SC",
    sp: "SP",
    se: "SE",
    to: "TO",
    // Nomes completos
    acre: "AC",
    alagoas: "AL",
    amapá: "AP",
    amapa: "AP",
    amazonas: "AM",
    bahia: "BA",
    ceará: "CE",
    ceara: "CE",
    "distrito federal": "DF",
    "espírito santo": "ES",
    "espirito santo": "ES",
    goiás: "GO",
    goias: "GO",
    maranhão: "MA",
    maranhao: "MA",
    "mato grosso": "MT",
    "mato grosso do sul": "MS",
    "minas gerais": "MG",
    pará: "PA",
    para: "PA",
    paraíba: "PB",
    paraiba: "PB",
    paraná: "PR",
    parana: "PR",
    pernambuco: "PE",
    piauí: "PI",
    piaui: "PI",
    "rio de janeiro": "RJ",
    "rio grande do norte": "RN",
    "rio grande do sul": "RS",
    rondônia: "RO",
    rondonia: "RO",
    roraima: "RR",
    "santa catarina": "SC",
    "são paulo": "SP",
    "sao paulo": "SP",
    sergipe: "SE",
    tocantins: "TO",
  };

  // Função para normalizar UF
  const normalizarUF = (valor) => {
    if (!valor) return "";

    const valorLimpo = valor.toString().toLowerCase().trim();
    return ESTADOS_BRASIL[valorLimpo] || "";
  };

  // Função para normalizar regime tributário
  const normalizarRegimeTributario = (valor) => {
    if (!valor) return "";

    const valorLimpo = valor
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, " ");

    const mapeamento = {
      "simples nacional": "simples_nacional",
      "lucro presumido": "lucro_presumido",
      "lucro real": "lucro_real",
    };

    return mapeamento[valorLimpo] || "";
  };

  // Função para processar arquivo Excel
  const processarArquivoExcel = async () => {
    if (!arquivoSelecionado) {
      mostrarSnackbar("Selecione um arquivo para importar", "error");
      return;
    }

    // Verificar se o arquivo ainda é válido
    try {
      // Tentar ler um pequeno pedaço do arquivo para verificar se ainda é acessível
      await arquivoSelecionado.slice(0, 100).arrayBuffer();
    } catch (error) {
      mostrarSnackbar(
        "O arquivo selecionado não está mais disponível. Selecione o arquivo novamente.",
        "error",
      );
      setArquivoSelecionado(null);
      const fileInput = document.getElementById("arquivo-upload");
      if (fileInput) fileInput.value = "";
      return;
    }

    setImportandoClientes(true);
    setResultadoImportacao(null);
    setProgressoImportacao(0);

    try {
      const data = await arquivoSelecionado.arrayBuffer();
      const workbook = XLSX.read(data, { type: "buffer" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      if (jsonData.length < 2) {
        mostrarSnackbar(
          "O arquivo deve conter pelo menos uma linha de dados além do cabeçalho",
          "error",
        );
        return;
      }

      const cabecalho = jsonData[0];
      const linhas = jsonData.slice(1);

      // Mapear índices das colunas
      const indices = {
        nome: cabecalho.findIndex(
          (col) =>
            col &&
            col.toString().toLowerCase().includes("nome") &&
            col.toString().includes("*"),
        ),
        fantasia: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("fantasia"),
        ),
        cnpj: cabecalho.findIndex(
          (col) =>
            col &&
            (col.toString().toLowerCase().includes("cnpj") ||
              col.toString().toLowerCase().includes("cpf")),
        ),
        email: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("email"),
        ),
        telefone: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("telefone"),
        ),
        natureza: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("natureza"),
        ),
        regime: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("regime"),
        ),
        cep: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("cep"),
        ),
        logradouro: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("logradouro"),
        ),
        numero: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("número"),
        ),
        complemento: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("complemento"),
        ),
        bairro: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("bairro"),
        ),
        cidade: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("cidade"),
        ),
        uf: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("uf"),
        ),
        observacoes: cabecalho.findIndex(
          (col) => col && col.toString().toLowerCase().includes("observa"),
        ),
      };

      const clientesParaImportar = [];
      const erros = [];

      linhas.forEach((linha, index) => {
        const numeroLinha = index + 2; // +2 porque começamos da linha 2 (após cabeçalho)

        // Pular linhas vazias
        if (
          !linha ||
          linha.every((cell) => !cell || cell.toString().trim() === "")
        ) {
          return;
        }

        const nome =
          indices.nome >= 0
            ? (linha[indices.nome] || "").toString().trim()
            : "";

        if (!nome) {
          erros.push(`Linha ${numeroLinha}: Nome é obrigatório`);
          return;
        }

        const cnpjOriginal =
          indices.cnpj >= 0
            ? (linha[indices.cnpj] || "").toString().trim()
            : "";
        const cnpjFormatado = cnpjOriginal ? formatCPFCNPJ(cnpjOriginal) : "";

        const regimeOriginal =
          indices.regime >= 0
            ? (linha[indices.regime] || "").toString().trim()
            : "";
        const regimeNormalizado = normalizarRegimeTributario(regimeOriginal);

        if (regimeOriginal && !regimeNormalizado) {
          erros.push(
            `Linha ${numeroLinha}: Regime tributário "${regimeOriginal}" não é válido. Use: Simples Nacional, Lucro Presumido ou Lucro Real`,
          );
        }

        // Validar CEP
        const cepOriginal =
          indices.cep >= 0 ? (linha[indices.cep] || "").toString().trim() : "";
        const cepNormalizado = normalizarCEP(cepOriginal);

        // Validar UF
        const ufOriginal =
          indices.uf >= 0 ? (linha[indices.uf] || "").toString().trim() : "";
        const ufNormalizada = normalizarUF(ufOriginal);

        if (ufOriginal && !ufNormalizada) {
          erros.push(
            `Linha ${numeroLinha}: UF "${ufOriginal}" não é válida. Use a sigla (SP, RJ, etc.) ou nome completo do estado`,
          );
        }

        const cliente = {
          nome,
          fantasia:
            indices.fantasia >= 0
              ? (linha[indices.fantasia] || "").toString().trim()
              : "",
          cnpj: cnpjFormatado,
          email:
            indices.email >= 0
              ? (linha[indices.email] || "").toString().trim()
              : "",
          telefone:
            indices.telefone >= 0
              ? (linha[indices.telefone] || "").toString().trim()
              : "",
          natureza:
            indices.natureza >= 0
              ? (linha[indices.natureza] || "").toString().trim()
              : "",
          regime_tributario: regimeNormalizado,
          cep: cepNormalizado,
          logradouro:
            indices.logradouro >= 0
              ? (linha[indices.logradouro] || "").toString().trim()
              : "",
          numero:
            indices.numero >= 0
              ? (linha[indices.numero] || "").toString().trim()
              : "",
          complemento:
            indices.complemento >= 0
              ? (linha[indices.complemento] || "").toString().trim()
              : "",
          bairro:
            indices.bairro >= 0
              ? (linha[indices.bairro] || "").toString().trim()
              : "",
          cidade:
            indices.cidade >= 0
              ? (linha[indices.cidade] || "").toString().trim()
              : "",
          uf: ufNormalizada,
          observacoes:
            indices.observacoes >= 0
              ? (linha[indices.observacoes] || "").toString().trim()
              : "",
          ativo: true,
        };

        clientesParaImportar.push({ cliente, linha: numeroLinha });
      });

      if (erros.length > 0) {
        setResultadoImportacao({
          sucesso: false,
          erros,
          total: linhas.length,
          processados: 0,
        });
        // Resetar arquivo para forçar nova seleção após correções
        setArquivoSelecionado(null);
        // Limpar o input file
        const fileInput = document.getElementById("arquivo-upload");
        if (fileInput) fileInput.value = "";
        return;
      }

      if (clientesParaImportar.length === 0) {
        mostrarSnackbar(
          "Nenhum cliente válido encontrado no arquivo",
          "warning",
        );
        return;
      }

      // Importar clientes em lote
      let sucessos = 0;
      const errosImportacao = [];

      for (let i = 0; i < clientesParaImportar.length; i++) {
        const { cliente, linha } = clientesParaImportar[i];

        try {
          await clienteService.create(cliente);
          sucessos++;
        } catch (error) {
          errosImportacao.push(
            `Linha ${linha} (${cliente.nome}): ${error.message}`,
          );
        }

        // Atualizar progresso
        const progresso = Math.round(
          ((i + 1) / clientesParaImportar.length) * 100,
        );
        setProgressoImportacao(progresso);
      }

      setResultadoImportacao({
        sucesso: sucessos > 0,
        sucessos,
        erros: errosImportacao,
        total: clientesParaImportar.length,
        processados: clientesParaImportar.length,
      });

      if (sucessos > 0) {
        carregarClientes(); // Recarregar a lista de clientes
      }
    } catch (error) {
      mostrarSnackbar("Erro ao processar arquivo: " + error.message, "error");
    } finally {
      setImportandoClientes(false);
    }
  };

  // Função para fechar modal de importação
  const fecharModalImportacao = () => {
    setModalImportacaoAberto(false);
    setArquivoSelecionado(null);
    setResultadoImportacao(null);
    setProgressoImportacao(0);
  };

  // Função para abrir modal de cópia de recorrências
  const abrirModalCopiaRecorrencias = (cliente) => {
    setClienteOrigemCopia(cliente);
    setClientesSelecionadosCopia([]);
    setTodosSelecionados(false);
    setResultadoCopia(null);
    setModalCopiaRecorrenciasAberto(true);
  };

  // Função para fechar modal de cópia de recorrências
  const fecharModalCopiaRecorrencias = () => {
    setModalCopiaRecorrenciasAberto(false);
    setClienteOrigemCopia(null);
    setClientesSelecionadosCopia([]);
    setTodosSelecionados(false);
    setResultadoCopia(null);
  };

  // Função para toggle de seleção de cliente para cópia
  const toggleClienteCopia = (clienteId) => {
    setClientesSelecionadosCopia((prev) => {
      if (prev.includes(clienteId)) {
        const novaSelecao = prev.filter((id) => id !== clienteId);
        // Se desmarcou um cliente, desmarcar "todos selecionados"
        if (prev.length === clientesDisponiveis.length) {
          setTodosSelecionados(false);
        }
        return novaSelecao;
      } else {
        const novaSelecao = [...prev, clienteId];
        // Se selecionou todos os clientes disponíveis, marcar "todos selecionados"
        if (novaSelecao.length === clientesDisponiveis.length) {
          setTodosSelecionados(true);
        }
        return novaSelecao;
      }
    });
  };

  // Função para toggle de todos os clientes
  const toggleTodosClientes = () => {
    if (todosSelecionados) {
      setClientesSelecionadosCopia([]);
      setTodosSelecionados(false);
    } else {
      setClientesSelecionadosCopia(clientesDisponiveis.map((c) => c.id));
      setTodosSelecionados(true);
    }
  };

  // Clientes disponíveis para cópia (excluindo o cliente de origem e inativos)
  const clientesDisponiveis = clientes.filter(
    (c) => c.id !== clienteOrigemCopia?.id && c.ativo,
  );

  // Função para copiar recorrências
  const copiarRecorrencias = async () => {
    if (clientesSelecionadosCopia.length === 0) {
      mostrarSnackbar(
        "Selecione pelo menos um cliente para copiar as recorrências",
        "warning",
      );
      return;
    }

    setCopiandoRecorrencias(true);
    setResultadoCopia(null);

    try {
      const response = await recorrenciaService.copyRecurrences({
        cliente_origem_id: clienteOrigemCopia.id,
        clientes_destino_ids: clientesSelecionadosCopia,
      });

      setResultadoCopia(response);

      const totalCriadas = response.resumo.total_recorrencias_criadas;
      const totalObrigacoes = response.resumo.total_obrigacoes_criadas;

      let mensagem = `${totalCriadas} recorrência(s) copiada(s) com sucesso!`;
      if (totalObrigacoes > 0) {
        mensagem += ` ${totalObrigacoes} obrigação(ões) gerada(s) automaticamente.`;
      }

      mostrarSnackbar(mensagem, "success");
    } catch (error) {
      mostrarSnackbar("Erro ao copiar recorrências: " + error.message, "error");
    } finally {
      setCopiandoRecorrencias(false);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 600, color: "#333" }}>
          Clientes
        </Typography>
        <Box>
          <Button
            variant="outlined"
            startIcon={<FilterIcon />}
            onClick={() => setMostrarFiltros(!mostrarFiltros)}
            sx={{ mr: 2 }}
          >
            Filtros
          </Button>
          <Button
            variant="outlined"
            startIcon={<UploadIcon />}
            onClick={() => setModalImportacaoAberto(true)}
            sx={{ mr: 2 }}
          >
            Importar
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => abrirModalCliente()}
            sx={{ backgroundColor: "#1976d2" }}
          >
            Novo cliente
          </Button>
        </Box>
      </Box>

      {/* Filtros */}
      {mostrarFiltros && (
        <Card
          sx={{
            mb: 3,
            p: 3,
            backgroundColor: "#f5f5f5",
            borderRadius: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{ mb: 2, color: "#333", fontWeight: 600 }}
          >
            Filtros
          </Typography>

          {/* ✅ SOLUÇÃO CSS PURA - Funciona em qualquer versão do Material-UI */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: "100%",
              flexWrap: { xs: "wrap", md: "nowrap" }, // Mobile: quebra linha, Desktop: mesma linha
              alignItems: "center",
            }}
          >
            {/* Campo de Busca */}
            <Box
              sx={{
                flex: `0 1 ${TAMANHOS_FILTROS.busca}%`,
                minWidth: { xs: "100%", md: "200px" },
                maxWidth: { md: `${TAMANHOS_FILTROS.busca}%` },
              }}
            >
              <TextField
                fullWidth
                size="medium"
                label="Buscar clientes"
                placeholder="Nome, fantasia ou CNPJ..."
                value={filtros.busca}
                onChange={(e) => handleFiltroChange("busca", e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                  },
                }}
              />
            </Box>

            {/* Campo de Status */}
            <Box
              sx={{
                flex: `0 1 ${TAMANHOS_FILTROS.status}%`,
                minWidth: { xs: "100%", md: "150px" },
                maxWidth: { md: `${TAMANHOS_FILTROS.status}%` },
              }}
            >
              <FormControl fullWidth size="medium">
                <InputLabel>Status</InputLabel>
                <Select
                  value={filtros.ativo}
                  label="Status"
                  onChange={(e) => handleFiltroChange("ativo", e.target.value)}
                  sx={{
                    backgroundColor: "white",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                    },
                  }}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="true">Ativo</MenuItem>
                  <MenuItem value="false">Inativo</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Campo de Escritório - apenas para super admin */}
            {user?.is_super_admin && (
              <Box
                sx={{
                  flex: `0 1 ${TAMANHOS_FILTROS.escritorio}%`,
                  minWidth: { xs: "100%", md: "150px" },
                  maxWidth: { md: `${TAMANHOS_FILTROS.escritorio}%` },
                }}
              >
                <FormControl fullWidth size="medium">
                  <InputLabel>Escritório</InputLabel>
                  <Select
                    value={filtros.escritorio_id_filter}
                    label="Escritório"
                    onChange={(e) =>
                      handleFiltroChange("escritorio_id_filter", e.target.value)
                    }
                    sx={{
                      backgroundColor: "white",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    <MenuItem value="">Todos os escritórios</MenuItem>
                    {escritorios.map((escritorio) => (
                      <MenuItem key={escritorio.id} value={escritorio.id}>
                        {escritorio.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
          </Box>

          {/* Botão para limpar filtros */}
          <Box sx={{ mt: 3 }}>
            <Button
              onClick={() => {
                setFiltros({ busca: "", ativo: "", escritorio_id_filter: "" });
                setPaginacao((prev) => ({ ...prev, page: 0 }));
              }}
              variant="outlined"
              size="small"
            >
              Limpar filtros
            </Button>
          </Box>
        </Card>
      )}

      {/* Tabela de clientes */}
      <Card>
        <ResponsiveTable
          data={clientes}
          loading={loading}
          emptyMessage="Nenhum cliente encontrado. Cadastre primeiro os tipos de obrigações, pois serão necessárias para criar as obrigações dos clientes automaticamente."
          columns={[
            { field: "nome", label: "Nome", minWidth: 200 },
            { field: "fantasia", label: "Fantasia", minWidth: 150 },
            { field: "cnpj", label: "CNPJ", minWidth: 140 },
            { field: "telefone", label: "Telefone", minWidth: 120 },
            { field: "email", label: "Email", minWidth: 200 },
            {
              field: "regime_tributario",
              label: "Regime tributário",
              minWidth: 150,
              format: (value) => {
                if (!value) return "-";
                const regimes = {
                  simples_nacional: "Simples nacional",
                  lucro_presumido: "Lucro presumido",
                  lucro_real: "Lucro real",
                };
                return regimes[value] || value;
              },
            },
            {
              field: "observacoes",
              label: "Observações",
              minWidth: 200,
              format: (value) => {
                if (!value) return "-";
                // Limitar o texto para não quebrar a tabela
                return value.length > 50
                  ? `${value.substring(0, 50)}...`
                  : value;
              },
            },
            {
              field: "ativo",
              label: "Status",
              chip: true,
              format: (value) => (value ? "Ativo" : "Inativo"),
              chipColor: (value) => (value ? "success" : "error"),
              minWidth: 100,
            },
            ...(user?.is_super_admin
              ? [
                  {
                    field: "escritorio",
                    label: "Escritório",
                    minWidth: 150,
                    format: (value) => value?.nome || "-",
                  },
                ]
              : []),
          ]}
          actions={[
            {
              icon: <EditIcon />,
              label: "Editar",
              color: "info",
              onClick: (cliente) => abrirModalCliente(cliente),
            },
            {
              icon: <ContentCopyIcon />,
              label: "Copiar recorrências",
              color: "secondary",
              onClick: (cliente) => abrirModalCopiaRecorrencias(cliente),
            },
            {
              icon: <DeleteIcon />,
              label: "Excluir",
              color: "error",
              onClick: (cliente) => confirmarExclusao(cliente),
            },
          ]}
        />
        <TablePagination
          component="div"
          count={paginacao.total}
          page={paginacao.page}
          onPageChange={(event, newPage) =>
            setPaginacao((prev) => ({ ...prev, page: newPage }))
          }
          rowsPerPage={paginacao.limit}
          onRowsPerPageChange={(event) => {
            setPaginacao((prev) => ({
              ...prev,
              limit: parseInt(event.target.value, 10),
              page: 0,
            }));
          }}
          labelRowsPerPage="Itens por página:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count}`
          }
        />
      </Card>

      {/* Modal de cliente */}
      <Dialog open={modalAberto} onClose={fecharModal} maxWidth="md" fullWidth>
        <DialogTitle>
          {clienteEditando ? "Editar cliente" : "Novo cliente"}
        </DialogTitle>
        <DialogContent>
          {/* Orientação quando não há tipos de obrigações cadastrados */}
          {!carregandoTiposObrigacao &&
            Array.isArray(tiposObrigacoesDisponiveis) &&
            tiposObrigacoesDisponiveis.length === 0 && (
              <Alert severity="error" sx={{ mb: 2 }}>
                Recomendamos criar os tipos de obrigações primeiro para poder
                criar recorrências ao novo cliente automaticamente.
              </Alert>
            )}
          {/* Layout baseado em Box e Flexbox, seguindo o padrão de Recorrencias.js */}
          <Box sx={{ mt: 2 }}>
            {/* --- Linha 1: CNPJ e Status --- */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  label="CPF/CNPJ"
                  value={dadosCliente.cnpj}
                  onChange={(e) => {
                    const formattedValue = formatCPFCNPJ(e.target.value);
                    handleInputChange("cnpj", formattedValue);
                    setCnpjError(null);
                  }}
                  error={Boolean(cnpjError)}
                  helperText={cnpjError || ""}
                  inputProps={{
                    maxLength: 18, // CPF: XXX.XXX.XXX-XX (14) ou CNPJ: XX.XXX.XXX/XXXX-XX (18)
                  }}
                  InputProps={{
                    endAdornment: dadosCliente.cnpj &&
                      dadosCliente.cnpj.replace(/\D/g, "").length === 14 && (
                        <InputAdornment position="end">
                          <Button
                            onClick={buscarCNPJ}
                            disabled={buscandoCNPJ}
                            size="small"
                            variant="outlined"
                          >
                            {buscandoCNPJ ? (
                              <CircularProgress size={18} />
                            ) : (
                              "Buscar CNPJ"
                            )}
                          </Button>
                        </InputAdornment>
                      ),
                  }}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={dadosCliente.ativo}
                    label="Status"
                    onChange={(e) => handleInputChange("ativo", e.target.value)}
                  >
                    <MenuItem value={true}>Ativo</MenuItem>
                    <MenuItem value={false}>Inativo</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>

            {/* --- Linha 2: Nome e Nome Fantasia --- */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  label="Nome *"
                  value={dadosCliente.nome}
                  onChange={(e) => handleInputChange("nome", e.target.value)}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  label="Nome fantasia"
                  value={dadosCliente.fantasia}
                  onChange={(e) =>
                    handleInputChange("fantasia", e.target.value)
                  }
                />
              </Box>
            </Box>

            {/* --- Linha 3: Email e Telefone --- */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  value={dadosCliente.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  label="Telefone"
                  value={dadosCliente.telefone}
                  onChange={(e) =>
                    handleInputChange("telefone", e.target.value)
                  }
                />
              </Box>
            </Box>

            {/* --- Linha 4: Natureza --- */}
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                label="Natureza"
                value={dadosCliente.natureza}
                onChange={(e) => handleInputChange("natureza", e.target.value)}
              />
            </Box>

            {/* --- Linha 5: Regime tributário --- */}
            <Box sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <InputLabel>Regime tributário</InputLabel>
                <Select
                  value={dadosCliente.regime_tributario}
                  label="Regime tributário"
                  onChange={(e) =>
                    handleInputChange("regime_tributario", e.target.value)
                  }
                >
                  <MenuItem value="">Selecione...</MenuItem>
                  <MenuItem value="simples_nacional">Simples nacional</MenuItem>
                  <MenuItem value="lucro_presumido">Lucro presumido</MenuItem>
                  <MenuItem value="lucro_real">Lucro real</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* --- Linha 6: Observações --- */}
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                label="Observações"
                value={dadosCliente.observacoes}
                onChange={(e) =>
                  handleInputChange("observacoes", e.target.value)
                }
                multiline
                rows={3}
                placeholder="Informações adicionais sobre o cliente..."
              />
            </Box>

            {/* --- Linha 7: Endereço (CEP, Logradouro, Número) --- */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  label="CEP"
                  value={dadosCliente.cep}
                  onChange={(e) => {
                    const valorFormatado = formatarCEP(e.target.value);
                    handleInputChange("cep", valorFormatado);

                    // Busca automática quando CEP estiver completo
                    if (valorFormatado.replace(/\D/g, "").length === 8) {
                      buscarCEP(valorFormatado);
                    }
                  }}
                  InputProps={{
                    endAdornment: buscandoCEP && (
                      <InputAdornment position="end">
                        <CircularProgress size={20} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box sx={{ flex: 2 }}>
                <TextField
                  fullWidth
                  label="Logradouro"
                  value={dadosCliente.logradouro}
                  onChange={(e) =>
                    handleInputChange("logradouro", e.target.value)
                  }
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  label="Número"
                  value={dadosCliente.numero}
                  onChange={(e) => handleInputChange("numero", e.target.value)}
                />
              </Box>
            </Box>

            {/* --- Linha 8: Endereço (Bairro, Complemento, Cidade, UF) --- */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  label="Bairro"
                  value={dadosCliente.bairro}
                  onChange={(e) => handleInputChange("bairro", e.target.value)}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  label="Complemento"
                  value={dadosCliente.complemento}
                  onChange={(e) =>
                    handleInputChange("complemento", e.target.value)
                  }
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  label="Cidade"
                  value={dadosCliente.cidade}
                  onChange={(e) => handleInputChange("cidade", e.target.value)}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <FormControl fullWidth>
                  <InputLabel>UF</InputLabel>
                  <Select
                    value={dadosCliente.uf}
                    label="UF"
                    onChange={(e) => handleInputChange("uf", e.target.value)}
                    MenuProps={{ PaperProps: { style: { minWidth: 100 } } }}
                  >
                    {UF_LIST.map((uf) => (
                      <MenuItem key={uf} value={uf}>
                        {uf}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={fecharModal}>Cancelar</Button>
          <Button
            onClick={salvarCliente}
            variant="contained"
            disabled={salvando}
          >
            {salvando ? (
              <CircularProgress size={20} />
            ) : clienteEditando ? (
              "Atualizar"
            ) : (
              "Criar"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de confirmação de exclusão */}
      <Dialog
        open={confirmacaoExclusao.aberto}
        onClose={() =>
          setConfirmacaoExclusao({
            aberto: false,
            clienteId: null,
            clienteNome: "",
          })
        }
      >
        <DialogTitle>Confirmar exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja excluir o cliente "
            {confirmacaoExclusao.clienteNome}"? Esta ação não pode ser desfeita.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setConfirmacaoExclusao({
                aberto: false,
                clienteId: null,
                clienteNome: "",
              })
            }
            color="primary"
          >
            Cancelar
          </Button>
          <Button
            onClick={excluirCliente}
            color="error"
            variant="contained"
            disabled={excluindo}
          >
            {excluindo ? <CircularProgress size={20} /> : "Excluir"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de recorrências automáticas */}
      <Dialog
        open={modalRecorrenciasAberto}
        onClose={fecharModalRecorrencias}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Criar recorrências automáticas para {clienteCriado?.nome}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {clienteCriado?.regime_tributario ? (
              <>
                O cliente possui regime tributário{" "}
                <strong>
                  {clienteCriado.regime_tributario.replace("_", " ")}
                </strong>
                . As obrigações compatíveis com este regime já estão marcadas.
                Você pode selecionar qualquer obrigação conforme sua
                necessidade:
              </>
            ) : (
              <>
                O cliente não possui regime tributário definido. Selecione
                manualmente as obrigações que deseja criar:
              </>
            )}
          </Typography>

          {loadingRecorrencias ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: 2,
              }}
            >
              {recorrenciasSelecionadas.map((recorrencia) => (
                <Box
                  key={recorrencia.tipo_obrigacao_id}
                  sx={{
                    p: 2,
                    border: 1,
                    borderColor: recorrencia.jaExiste ? "grey.300" : "divider",
                    borderRadius: 1,
                    backgroundColor: recorrencia.jaExiste
                      ? "grey.50"
                      : "transparent",
                    opacity: recorrencia.jaExiste ? 0.6 : 1,
                  }}
                >
                  {recorrencia.jaExiste ? (
                    // Para recorrências que já existem - sem checkbox
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 1,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography variant="body1" color="text.secondary">
                            {recorrencia.tipo_obrigacao.descricao}
                          </Typography>
                          <Chip
                            label="Recorrência já existente"
                            size="small"
                            color="default"
                            variant="outlined"
                            sx={{ fontSize: "0.75rem", height: "20px" }}
                          />
                          {recorrencia.isCompatible && (
                            <Chip
                              label="Compatível"
                              size="small"
                              color="success"
                              variant="outlined"
                              sx={{ fontSize: "0.75rem", height: "20px" }}
                            />
                          )}
                        </Box>
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          startIcon={<DeleteIcon />}
                          onClick={() =>
                            confirmarExclusaoRecorrencia(
                              recorrencia.recorrenciaExistente,
                            )
                          }
                          sx={{
                            fontSize: "0.75rem",
                            minWidth: "auto",
                            px: 1,
                          }}
                        >
                          Excluir recorrência
                        </Button>
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        Recorrência:{" "}
                        {recorrencia.tipo_obrigacao.mes_recorrente
                          ? `Anual - Dia ${recorrencia.tipo_obrigacao.dia_recorrente} do mês ${recorrencia.tipo_obrigacao.mes_recorrente}`
                          : `Mensal - Dia ${recorrencia.tipo_obrigacao.dia_recorrente}`}
                      </Typography>
                    </Box>
                  ) : (
                    // Para recorrências que podem ser criadas - com checkbox
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={recorrencia.selecionado}
                          onChange={() =>
                            toggleRecorrencia(recorrencia.tipo_obrigacao_id)
                          }
                        />
                      }
                      label={
                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Typography variant="body1">
                              {recorrencia.tipo_obrigacao.descricao}
                            </Typography>
                            {recorrencia.isCompatible && (
                              <Chip
                                label="Compatível"
                                size="small"
                                color="success"
                                variant="outlined"
                                sx={{ fontSize: "0.75rem", height: "20px" }}
                              />
                            )}
                          </Box>
                          <Typography variant="body2" color="text.secondary">
                            Recorrência:{" "}
                            {recorrencia.tipo_obrigacao.mes_recorrente
                              ? `Anual - Dia ${recorrencia.tipo_obrigacao.dia_recorrente} do mês ${recorrencia.tipo_obrigacao.mes_recorrente}`
                              : `Mensal - Dia ${recorrencia.tipo_obrigacao.dia_recorrente}`}
                          </Typography>
                        </Box>
                      }
                    />
                  )}

                  {recorrencia.selecionado && !recorrencia.jaExiste && (
                    <Box sx={{ mt: 2, ml: 4 }}>
                      <FormControl size="small" sx={{ minWidth: 200 }}>
                        <InputLabel>Setor</InputLabel>
                        <Select
                          value={recorrencia.setor_id || ""}
                          label="Setor"
                          onChange={(e) =>
                            alterarSetorRecorrencia(
                              recorrencia.tipo_obrigacao_id,
                              e.target.value,
                            )
                          }
                        >
                          <MenuItem value="">Sem setor</MenuItem>
                          {setores.map((setor) => (
                            <MenuItem key={setor.id} value={setor.id}>
                              {setor.descricao}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          )}

          <Alert severity="info" sx={{ mt: 2 }}>
            <Typography variant="body2">
              <strong>Importante:</strong> Além das recorrências, serão criadas
              automaticamente as primeiras obrigações de cada tipo selecionado
              com as datas de vencimento calculadas a partir das regras de
              recorrência.
            </Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={fecharModalRecorrencias}
            disabled={loadingRecorrencias}
          >
            Pular
          </Button>
          <Button
            onClick={criarRecorrenciasLote}
            variant="contained"
            disabled={
              loadingRecorrencias ||
              recorrenciasSelecionadas.filter(
                (r) => r.selecionado && !r.jaExiste,
              ).length === 0
            }
          >
            {loadingRecorrencias ? (
              <CircularProgress size={20} />
            ) : (
              "Criar recorrências"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de importação de clientes */}
      <Dialog
        open={modalImportacaoAberto}
        onClose={fecharModalImportacao}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Importar clientes via Excel</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            {/* Instruções */}
            <Alert severity="info" sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                Como importar seus clientes:
              </Typography>
              <Typography variant="body2" component="div">
                <Box component="ol" sx={{ pl: 2, m: 0 }}>
                  <li>Baixe o modelo Excel clicando no botão abaixo</li>
                  <li>Preencha seus dados seguindo o exemplo na planilha</li>
                  <li>Apenas o campo "Nome*" é obrigatório</li>
                  <li>
                    Para "Regime Tributário", use: Simples Nacional, Lucro
                    Presumido ou Lucro Real
                  </li>
                  <li>
                    CPF/CNPJ pode ter formatação (pontos/traços) ou apenas
                    números
                  </li>
                  <li>
                    CEP: use apenas números e traços (outros caracteres serão
                    ignorados)
                  </li>
                  <li>
                    UF: use a sigla (SP, RJ) ou nome completo (São Paulo, Rio de
                    Janeiro)
                  </li>
                  <li>
                    Selecione seu arquivo preenchido e clique em "Importar"
                  </li>
                </Box>
              </Typography>
            </Alert>

            {/* Botão para baixar modelo */}
            <Box sx={{ mb: 3, textAlign: "center" }}>
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={baixarModeloExcel}
                sx={{ backgroundColor: "#4caf50" }}
              >
                Baixar modelo Excel
              </Button>
            </Box>

            {/* Seleção de arquivo */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Selecione seu arquivo:
              </Typography>
              <Box
                sx={{
                  border: "2px solid #ccc",
                  borderRadius: 1,
                  p: 3,
                  textAlign: "center",
                  backgroundColor: arquivoSelecionado ? "#f0f8f0" : "#fafafa",
                }}
              >
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={(e) => setArquivoSelecionado(e.target.files[0])}
                  style={{ display: "none" }}
                  id="arquivo-upload"
                />
                <label htmlFor="arquivo-upload">
                  <Button
                    variant="outlined"
                    component="span"
                    startIcon={<CloudUploadIcon />}
                    sx={{ mb: 2 }}
                  >
                    {arquivoSelecionado
                      ? "Trocar arquivo"
                      : "Selecionar arquivo"}
                  </Button>
                </label>
                {arquivoSelecionado && (
                  <Typography variant="body2" color="success.main">
                    ✓ Arquivo selecionado: {arquivoSelecionado.name}
                  </Typography>
                )}
                {!arquivoSelecionado && resultadoImportacao?.erros && (
                  <Typography variant="body2" color="warning.main">
                    ⚠️ Selecione novamente o arquivo após fazer as correções
                  </Typography>
                )}
                {!arquivoSelecionado && !resultadoImportacao && (
                  <Typography variant="body2" color="text.secondary">
                    Clique no botão acima para selecionar um arquivo Excel
                  </Typography>
                )}
              </Box>
            </Box>

            {/* Indicador de progresso */}
            {importandoClientes && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Importando clientes... {progressoImportacao}%
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={progressoImportacao}
                  sx={{ height: 8, borderRadius: 4 }}
                />
              </Box>
            )}

            {/* Resultado da importação */}
            {resultadoImportacao && (
              <Box sx={{ mb: 3 }}>
                <Alert
                  severity={resultadoImportacao.sucesso ? "success" : "error"}
                  sx={{ mb: 2 }}
                >
                  <Typography variant="h6">Resultado da importação:</Typography>
                  {resultadoImportacao.sucesso ? (
                    <Typography>
                      {resultadoImportacao.sucessos} de{" "}
                      {resultadoImportacao.total} clientes importados com
                      sucesso!
                    </Typography>
                  ) : (
                    <Typography>
                      Foram encontrados erros no arquivo. Corrija-os, salve o
                      arquivo e selecione-o novamente para importar.
                    </Typography>
                  )}
                </Alert>

                {resultadoImportacao.erros &&
                  resultadoImportacao.erros.length > 0 && (
                    <Box
                      sx={{
                        maxHeight: 200,
                        overflow: "auto",
                        border: 1,
                        borderColor: "error.main",
                        borderRadius: 1,
                        p: 2,
                        backgroundColor: "#fff3f3",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        color="error"
                        sx={{ mb: 1 }}
                      >
                        Erros encontrados:
                      </Typography>
                      {resultadoImportacao.erros.map((erro, index) => (
                        <Typography
                          key={index}
                          variant="body2"
                          color="error"
                          sx={{ fontSize: "0.875rem" }}
                        >
                          • {erro}
                        </Typography>
                      ))}
                    </Box>
                  )}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={fecharModalImportacao}>
            {resultadoImportacao?.sucesso ? "Fechar" : "Cancelar"}
          </Button>
          {!resultadoImportacao?.sucesso && (
            <Button
              onClick={processarArquivoExcel}
              variant="contained"
              disabled={!arquivoSelecionado || importandoClientes}
              startIcon={
                importandoClientes ? (
                  <CircularProgress size={20} />
                ) : (
                  <UploadIcon />
                )
              }
            >
              {importandoClientes ? "Importando..." : "Importar clientes"}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Modal de cópia de recorrências */}
      <Dialog
        open={modalCopiaRecorrenciasAberto}
        onClose={fecharModalCopiaRecorrencias}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Copiar recorrências de {clienteOrigemCopia?.nome}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Selecione os clientes que devem receber uma cópia de todas as
            recorrências do cliente <strong>{clienteOrigemCopia?.nome}</strong>.
            As recorrências serão copiadas com as mesmas configurações e
            obrigações automáticas serão criadas.
          </Typography>

          {clientesDisponiveis.length === 0 ? (
            <Alert severity="info">
              Não há outros clientes ativos disponíveis para receber as
              recorrências.
            </Alert>
          ) : (
            <>
              {/* Controle para selecionar todos */}
              <Box
                sx={{
                  mb: 2,
                  p: 2,
                  backgroundColor: "#f5f5f5",
                  borderRadius: 1,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={todosSelecionados}
                      indeterminate={
                        clientesSelecionadosCopia.length > 0 &&
                        clientesSelecionadosCopia.length <
                          clientesDisponiveis.length
                      }
                      onChange={toggleTodosClientes}
                    />
                  }
                  label={
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      Selecionar todos os clientes ({clientesDisponiveis.length}
                      )
                    </Typography>
                  }
                />
              </Box>

              {/* Lista de clientes */}
              <Box
                sx={{
                  maxHeight: 400,
                  overflow: "auto",
                  border: 1,
                  borderColor: "divider",
                  borderRadius: 1,
                  backgroundColor: "background.paper",
                }}
              >
                {clientesDisponiveis.map((cliente) => (
                  <Box
                    key={cliente.id}
                    sx={{
                      p: 2,
                      borderBottom: "1px solid",
                      borderColor: "divider",
                      "&:last-child": { borderBottom: "none" },
                      "&:hover": { backgroundColor: "action.hover" },
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={clientesSelecionadosCopia.includes(
                            cliente.id,
                          )}
                          onChange={() => toggleClienteCopia(cliente.id)}
                        />
                      }
                      label={
                        <Box>
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {cliente.nome}
                          </Typography>
                          {cliente.fantasia && (
                            <Typography variant="body2" color="text.secondary">
                              {cliente.fantasia}
                            </Typography>
                          )}
                          {cliente.cnpj && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              CNPJ: {cliente.cnpj}
                            </Typography>
                          )}
                        </Box>
                      }
                      sx={{ width: "100%", margin: 0 }}
                    />
                  </Box>
                ))}
              </Box>

              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                {clientesSelecionadosCopia.length} de{" "}
                {clientesDisponiveis.length} clientes selecionados
              </Typography>

              {/* Resultado da cópia */}
              {resultadoCopia && (
                <Box sx={{ mt: 3 }}>
                  <Alert
                    severity={
                      resultadoCopia.resumo.total_recorrencias_criadas > 0
                        ? "success"
                        : "warning"
                    }
                    sx={{ mb: 2 }}
                  >
                    <Typography variant="h6">Resultado da cópia:</Typography>
                    <Typography>
                      {resultadoCopia.resumo.total_recorrencias_criadas}{" "}
                      recorrência(s) copiada(s)
                      {resultadoCopia.resumo.total_obrigacoes_criadas > 0 &&
                        ` e ${resultadoCopia.resumo.total_obrigacoes_criadas} obrigação(ões) criada(s)`}{" "}
                      para {resultadoCopia.resumo.clientes_processados}{" "}
                      cliente(s).
                    </Typography>
                  </Alert>

                  {/* Detalhes por cliente */}
                  <Box sx={{ maxHeight: 200, overflow: "auto" }}>
                    {Object.entries(resultadoCopia.detalhes_por_cliente).map(
                      ([clienteId, detalhe]) => (
                        <Box
                          key={clienteId}
                          sx={{
                            mb: 1,
                            p: 1,
                            backgroundColor: "grey.50",
                            borderRadius: 1,
                          }}
                        >
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {detalhe.nome}:
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {detalhe.recorrencias_criadas} recorrência(s),{" "}
                            {detalhe.obrigacoes_criadas} obrigação(ões)
                            {detalhe.erros.length > 0 &&
                              ` - ${detalhe.erros.length} erro(s)`}
                          </Typography>
                          {detalhe.erros.map((erro, index) => (
                            <Typography
                              key={index}
                              variant="caption"
                              color="error"
                              display="block"
                            >
                              • {erro}
                            </Typography>
                          ))}
                        </Box>
                      ),
                    )}
                  </Box>
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={fecharModalCopiaRecorrencias}>
            {resultadoCopia ? "Fechar" : "Cancelar"}
          </Button>
          {!resultadoCopia && clientesDisponiveis.length > 0 && (
            <Button
              onClick={copiarRecorrencias}
              variant="contained"
              disabled={
                clientesSelecionadosCopia.length === 0 || copiandoRecorrencias
              }
              startIcon={
                copiandoRecorrencias ? (
                  <CircularProgress size={20} />
                ) : (
                  <ContentCopyIcon />
                )
              }
            >
              {copiandoRecorrencias ? "Copiando..." : "Copiar recorrências"}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Modal de confirmação de exclusão de recorrência */}
      <Dialog
        open={confirmacaoExclusaoRecorrencia.aberto}
        onClose={() =>
          setConfirmacaoExclusaoRecorrencia({
            aberto: false,
            recorrenciaId: null,
            tipoObrigacaoDescricao: "",
            clienteNome: "",
          })
        }
      >
        <DialogTitle>Confirmar exclusão de recorrência</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Tem certeza que deseja excluir a recorrência "
            <strong>
              {confirmacaoExclusaoRecorrencia.tipoObrigacaoDescricao}
            </strong>
            " do cliente "
            <strong>{confirmacaoExclusaoRecorrencia.clienteNome}</strong>"?
          </Typography>
          <Alert severity="warning" sx={{ mt: 2 }}>
            <Typography variant="body2">
              <strong>Atenção:</strong> Esta ação também excluirá todas as
              obrigações pendentes associadas a esta recorrência. Esta ação não
              pode ser desfeita.
            </Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setConfirmacaoExclusaoRecorrencia({
                aberto: false,
                recorrenciaId: null,
                tipoObrigacaoDescricao: "",
                clienteNome: "",
              })
            }
            color="primary"
          >
            Cancelar
          </Button>
          <Button
            onClick={excluirRecorrencia}
            color="error"
            variant="contained"
            disabled={excluindoRecorrencia}
            startIcon={
              excluindoRecorrencia ? (
                <CircularProgress size={18} />
              ) : (
                <DeleteIcon />
              )
            }
          >
            {excluindoRecorrencia ? "Excluindo..." : "Excluir recorrência"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar para notificações */}
      <Snackbar
        open={snackbar.aberto}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, aberto: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, aberto: false })}
          severity={snackbar.tipo}
          sx={{ width: "100%" }}
        >
          {snackbar.mensagem}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Clientes;
